export type Breadcrumb = { name: string; path: string };

export const buildBreadcrumbJsonLd = (origin: string, items: Breadcrumb[]): string =>
  JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((b, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: b.name,
      item: `${origin}${b.path === '/' ? '' : b.path}`,
    })),
  });
